import PageHeader from '@/components_legacy/common/PageHeader';
import Footer from '@/widgets/footer';

const AGREEMENT_CONTENT = [
  {
    title: 'Purpose and Scope',
    list: [
      "Ambassador Role: The Ambassador agrees to create and deliver video featuring or promoting the Bumpy App (the 'Content'), as directed by the guidelines and instructions provided by Bumpy Inc. These videos will showcase specific features, services, or functions of the App for use in the Company’s marketing and social media campaigns.",
      'Duration: This Agreement becomes effective upon the date of signing and will continue unless terminated by either party in accordance with the Termination section.',
    ],
  },
  {
    title: 'Submission and Content Requirements',
    list: [
      'Content Submission: The Ambassador will produce and submit at least one video in digital format that complies with the creative brief provided by Bumpy Inc. The video should be of high quality and align with the brand’s values and image. The video submission must be completed and delivered via the method specified by Bumpy Inc.',
      'Adherence to Guidelines: The Ambassador agrees to strictly follow the creative brief provided by Bumpy Inc. Any deviation from the instructions may result in non-acceptance of the Content, and the Company reserves the right to request edits or re-shoots at the Ambassador’s expense.',
      'Content Ownership and Control: The Ambassador acknowledges that once the video is submitted, Bumpy Inc. has full creative control over how the Content is edited, adapted, and distributed across various platforms, including but not limited to social media channels, websites, emails, and paid advertising.',
    ],
  },
  {
    title: 'License to Use Content',
    list: [
      'Grant of License: The Ambassador grants Bumpy Inc. an unlimited, perpetual, irrevocable, worldwide, and royalty-free license to use, modify, distribute, reproduce, and display the Content for any and all commercial, promotional, and marketing purposes, without further approval or compensation to the Ambassador. This license applies to all media now known or hereafter devised.',
      'Perpetual Use: The license to the Content is granted to Bumpy Inc. without any expiration. The Company may use the Content for as long as it desires, without any requirement to provide further notice to the Ambassador or make any additional payments.',
      'No Further Compensation: The Ambassador agrees that the one-month free subscription to the Bumpy App constitutes the full and final compensation for the Content. The Ambassador waives any right to claim any future payments, royalties, or other compensation related to the use of the Content in perpetuity.',
    ],
  },
  {
    title: 'Compensation',
    list: [
      'Subscription Offer: Upon successful submission and approval of the Content, the Ambassador will receive a free one-month subscription to the Bumpy App. This subscription will be activated upon the acceptance of the Content by Bumpy Inc.',
      'No Additional Compensation: The Ambassador acknowledges that no monetary payments, royalties, or other forms of compensation will be provided beyond the one-month free subscription. The Ambassador agrees that no claims for future payment will be made against Bumpy Inc. for the Content submitted.',
      'Tax Responsibility: The Ambassador acknowledges that any tax obligations resulting from the one-month subscription or any other non-monetary compensation provided under this Agreement are solely the Ambassador’s responsibility. Bumpy Inc. will not provide any tax advice or withhold any taxes on behalf of the Ambassador.',
    ],
  },
  {
    title: 'Exclusivity',
    list: [
      'Non-Compete Agreement: The Ambassador agrees not to engage in the promotion, endorsement, or advertisement of any app, product, or service that competes directly or indirectly with the Bumpy App. This restriction applies both during the term of this Agreement and for a period of one year following the termination of this Agreement.',
      'Breach of Exclusivity: If the Ambassador violates this exclusivity provision, Bumpy Inc. reserves the right to terminate this Agreement immediately, and the Ambassador will forfeit any remaining benefits, including the one-month subscription. The Ambassador may also be liable for damages resulting from the breach.',
    ],
  },
  {
    title: 'Ambassador’s Representations and Warranties',
    list: [
      'Original Work: The Ambassador represents and warrants that the Content created and submitted under this Agreement is their own original work and does not infringe upon the intellectual property rights, privacy rights, or any other rights of any third party.',
      'Age and Legal Capacity: The Ambassador confirms that they are at least 18 years old and have the legal right to enter into this Agreement and grant the rights described herein.',
      'No Endorsement of Competing Products: The Ambassador affirms that they are not currently engaged in any agreements that would conflict with the obligations under this Agreement, specifically with regard to promoting competing apps or services.',
    ],
  },
  {
    title: 'Bumpy Inc. Rights and Responsibilities',
    list: [
      'Content Use: Bumpy Inc. reserves the right to edit, modify, or refuse the use of the Content if it does not meet the company’s standards, even after initial submission by the Ambassador. This includes editing the video to align with brand messaging and creative direction.',
      'No Liability for Use: Bumpy Inc. will not be held liable for any claims arising from its use of the Content, including any unintended consequences related to its distribution or modification. The Ambassador acknowledges that once the Content is submitted, Bumpy Inc. is not obligated to provide any further compensation or benefits beyond the initial agreed-upon terms.',
    ],
  },
  {
    title: 'Termination',
    list: [
      'Termination by Bumpy Inc.: Bumpy Inc. reserves the right to terminate this Agreement at any time and for any reason, including but not limited to breaches of the exclusivity clause or failure to submit the Content by the agreed deadline.',
      'Termination by Ambassador: The Ambassador may terminate this Agreement upon written notice to Bumpy Inc. However, if termination occurs after the Content has been submitted, the license to use the Content remains in effect, and no additional compensation will be provided.',
      'Effects of Termination: Upon termination, all rights granted to Bumpy Inc. to use the Content will remain in effect, and the Ambassador will not be entitled to any further compensation.',
    ],
  },
  {
    title: 'Confidentiality',
    list: [
      'Confidential Information: The Ambassador agrees not to disclose any confidential information provided by Bumpy Inc., including details about the App’s marketing strategies, operational practices, or future plans. This obligation extends beyond the termination of this Agreement.',
    ],
  },
  {
    title: 'Miscellaneous',
    list: [
      'Governing Law: This Agreement shall be governed by and construed in accordance with the laws of Delaware state.',
      'Entire Agreement: This Agreement constitutes the entire agreement between the Parties and supersedes any prior agreements, discussions, or negotiations, whether oral or written, concerning the subject matter hereof, except Bumpy Terms of Service, Privacy Policy, and any other company policy.',
      'Amendments: Any amendments or modifications to this Agreement can be posted on the Bumpy website, and the Parties agree that it comes into force the day it is posted.',
      'Severability: If any provision of this Agreement is found to be invalid or unenforceable by a court of competent jurisdiction, the remainder of this Agreement will remain in full force and effect.',
      'Waiver: No waiver of any term or condition in this Agreement shall be construed as a waiver of any other term or condition.',
    ],
  },
];

const AmbassadorAgreement = () => {
  return (
    <div className="overflow-auto">
      <PageHeader
        goBack={() => ''}
        withoutButton
        title="Bumpy Ambassador Public Agreement"
        className="sticky top-0"
      />
      <div className="my-10 flex flex-col gap-2 px-12 sm:px-20">
        <p className="mb-4 text-center">
          <strong>Updated 29.09.2024</strong>
        </p>
        <p className="text-primary">
          This public agreement ("Agreement") is entered into by and between:
        </p>
        <p className="font-bold">Bumpy Inc.</p>
        <p>
          (“Company,” “Bumpy Inc.,” or “We”), a corporation operating the Bumpy
          App (the "App"), having its principal place of business at Delaware,
          USA
        </p>
        <p className="text-primary">AND</p>
        <p className="font-bold">Ambassador</p>
        <p>
          physical person, user of the App, who enters this Agreement by taking
          part in the Ambassador program in the App ("Ambassador," “You,” or
          “Your”), Together, the "Parties" agree as follows:
        </p>
      </div>
      <ol className="flex flex-col gap-8 px-12 sm:px-20">
        {AGREEMENT_CONTENT.map((section, index) => (
          <li key={index}>
            <h2 className="font-bold text-xl">{`${index + 1}. ${section.title}`}</h2>
            <ol className="list-disc pt-4 pl-8">
              {section.list.map((item, subIndex) => (
                <li key={subIndex}>{item}</li>
              ))}
            </ol>
          </li>
        ))}
      </ol>
      <Footer hasShadow />
    </div>
  );
};

export default AmbassadorAgreement;
